<template>
  <div
    class="content-pane"
    data-v-sticky-container
  >
    <BackToTop />
    <div>
      <slot />
    </div>
  </div>
</template>
